module.exports = __webpack_public_path__ + "static/media/file-gif.6f2789e0.svg";